module.exports = __webpack_public_path__ + "static/media/no-data.cf50c8cd.svg";